import { useCallback, useReducer } from 'react';

// ✅ Phase 3: Separate UI modal state from business logic
interface ModalState {
    showTransactionModal: boolean;
    showCompleteConfirmModal: boolean;
}

type ModalAction =
    | { type: 'SET_MODAL'; payload: { modal: keyof ModalState; open: boolean } }
    | { type: 'RESET_MODALS' };

const initialState: ModalState = {
    showTransactionModal: false,
    showCompleteConfirmModal: false,
};

function modalReducer(state: ModalState, action: ModalAction): ModalState {
    switch (action.type) {
        case 'SET_MODAL':
            return {
                ...state,
                [action.payload.modal]: action.payload.open,
            };
        case 'RESET_MODALS':
            return initialState;
        default:
            return state;
    }
}

function useModalState() {
    const [state, dispatch] = useReducer(modalReducer, initialState);

    const setModalState = useCallback((modal: keyof ModalState, open: boolean) => {
        dispatch({ type: 'SET_MODAL', payload: { modal, open } });
    }, []);

    const resetModals = useCallback(() => {
        dispatch({ type: 'RESET_MODALS' });
    }, []);

    return {
        // State
        modalState: state,

        // Actions
        setModalState,
        resetModals,
    };
}

export default useModalState;
